<template>
  <div id="app" ref="app">
    <Main />
    <Form />
  </div>
</template>

<script>
import Main from "./components/Main";
import Form from "./components/Form";

import "normalize.css/normalize.css";

export default {
  name: "app",

  mounted() {
    this.$ga.page("/");

    setTimeout(
      () =>
        this.$ga.event(
          "Страница",
          "10 секунд на странице",
          "10 секунд на странице"
        ),
      10000
    );
  },
  components: {
    Main,
    Form
  }
};
import "aos/dist/aos.css";
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:300,500,400&subset=cyrillic");

#app {
  font-family: "Roboto", sans-serif;
  font-weight: 500;

  max-width: 670px;
  width: 100%;
  height: 720px;
  overflow: hidden;

  @media screen and (max-width: 669px) {
    width: 100%;
  }

  button {
    cursor: pointer;
  }
}
</style>
